import React, { useEffect } from 'react'

function DuplicateImportModal({ 
  isOpen, 
  onClose, 
  fileName,
  existingFile,
  onConfirm 
}) {
  // Handle escape key
  useEffect(() => {
    function handleEscape(e) {
      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }
    
    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      return () => document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) {
    return null
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown'
    try {
      const date = new Date(dateString)
      return date.toLocaleString()
    } catch {
      return dateString
    }
  }

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="duplicate-import-title"
      aria-describedby="duplicate-import-description"
      style={{ zIndex: 10000 }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '500px',
          width: '90%',
          maxHeight: '80vh',
          overflow: 'auto',
          position: 'relative',
          padding: 0
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 24px',
          background: 'var(--panel)',
          borderBottom: '1px solid var(--border)',
          borderRadius: '16px 16px 0 0'
        }}>
          <h2 id="duplicate-import-title" style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: 'var(--text-primary)', display: 'flex', alignItems: 'center' }}>
            <i className="fas fa-exclamation-triangle" aria-hidden="true" style={{ color: 'var(--color-orange-600)', marginRight: '8px' }}></i>
            File Already Exists
          </h2>
          <button
            onClick={onClose}
            className="ghost"
            style={{
              fontSize: '24px',
              padding: '4px',
              width: '32px',
              height: '32px',
              minWidth: 'auto',
              minHeight: 'auto'
            }}
            aria-label="Close duplicate import modal"
          >
            ×
          </button>
        </div>
        <div style={{ padding: '20px 24px' }}>
          <div id="duplicate-import-description" style={{ marginBottom: '20px' }}>
            <p style={{ marginBottom: '12px', fontSize: '15px', lineHeight: '1.6', color: 'var(--text)' }}>
              A file with the same name and UUID already exists in the database:
            </p>
            <div style={{ 
              padding: '12px 16px', 
              background: 'var(--color-warning-bg)', 
              borderRadius: '8px',
              border: '1px solid var(--color-warning-border)',
              fontSize: 'var(--text-xs)',
              lineHeight: '1.5',
              color: 'var(--color-orange-800)',
              marginBottom: '16px'
            }}>
              <div style={{ marginBottom: '8px' }}>
                <strong>File Name:</strong> {fileName || existingFile?.name || 'Unknown'}
              </div>
              {existingFile?.friendly_filename && existingFile.friendly_filename !== fileName && (
                <div style={{ marginBottom: '8px' }}>
                  <strong>Friendly Name:</strong> {existingFile.friendly_filename}
                </div>
              )}
              {existingFile?.created_at && (
                <div style={{ marginBottom: '8px' }}>
                  <strong>Imported:</strong> {formatDate(existingFile.created_at)}
                </div>
              )}
              {existingFile?.id && (
                <div style={{ fontSize: 'var(--text-xs)', color: 'var(--muted)', fontFamily: 'monospace' }}>
                  <strong>ID:</strong> {existingFile.id}
                </div>
              )}
            </div>
            <p style={{ marginBottom: '12px', fontSize: '15px', lineHeight: '1.6', color: 'var(--text)' }}>
              Are you sure you want to import this file again? This will create duplicate entries in your knowledge base.
            </p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
            <button
              onClick={onClose}
              className="secondary"
              style={{
                fontSize: '14px',
                fontWeight: '500'
              }}
              aria-label="Cancel import"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="primary"
              style={{
                fontSize: '14px',
                fontWeight: '500',
                backgroundColor: 'var(--color-orange-600)',
                borderColor: 'var(--color-orange-600)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'var(--color-orange-700)'
                e.target.style.borderColor = 'var(--color-orange-700)'
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'var(--color-orange-600)'
                e.target.style.borderColor = 'var(--color-orange-600)'
              }}
              aria-label="Import anyway"
            >
              Import Anyway
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DuplicateImportModal

